import { IClientOption } from '~/store/client/types';

import { ClientWithAllocation } from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/shared/model/types';

export const buildOriginalAllocationIdsByClientId = (fields: ClientWithAllocation[]) =>
  new Map(
    fields.flatMap(field => {
      const allocationId = field.allocation?.id || field.allocationId;
      return allocationId ? [[field.clientId, allocationId] as const] : [];
    }),
  );

export const getSelectionDiff = (previousIds: number[], selectedIds: number[]) => ({
  removedIds: previousIds.filter(id => !selectedIds.includes(id)),
  retainedIds: selectedIds.filter(id => previousIds.includes(id)),
});

export const buildSelectedOptions = (
  options: IClientOption[],
  currentAllocations: ClientWithAllocation[],
): Array<IClientOption | ClientWithAllocation> => {
  if (!options.length) return [];

  const hasExistingOption = currentAllocations.some(field =>
    options.some(option => option.id === field.id),
  );

  return hasExistingOption ? options : [...currentAllocations, ...options];
};
